module.exports = __webpack_public_path__ + "img/bus-dark-grey.0fa18c0f.svg";